import { Component, OnInit, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { V1RedirectUrls } from '../../constants/v1-redirect-urls.constants';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AvatarComponent } from "../avatar/avatar.component";
import { UserRole } from '../../models/user-roles.enum';
import { NavigationHistoryService } from '../../services/navigation-history.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [NgbModule, CommonModule, FormsModule, RouterModule, AvatarComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit {
  public user: User;
  public fullName: string;
  public canAccessFuelManagement = false;
  public canAccessDrivers = false;
  public canAccessAssetIQ = false;

  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly navigationHistory = inject(NavigationHistoryService);

  public async ngOnInit(): Promise<void> {
    this.user = this.authService.getUser();

    if (this.user) {
      this.fullName = `${this.user.firstName} ${this.user.lastName}`;
      const isBetaUser = this.authService.hasRole(UserRole.GTBETAUser);
      this.canAccessFuelManagement = isBetaUser || this.authService.hasRole(UserRole.GTFuelManagementBetaUser);
      this.canAccessDrivers = isBetaUser || this.authService.hasRole(UserRole.GTMyDriversBetaUser);
      this.canAccessAssetIQ = isBetaUser || this.authService.hasRole(UserRole.GTAssetIQBetaUser);
    }
  }

  public async logout(): Promise<void> {
    this.router.navigate(['/logout']);
  }

  public redirectToSupportPage(): void {
    const supportUrl = environment.supportUrl;
    window.open(supportUrl, '_blank');
  }

  get isSettingsActive(): boolean {
    return this.router.url.includes('/settings');
  }

  public redirectToSettingsPage(): void {
    if (this.router.url.includes('asset-management')) {
      this.navigationHistory.setBackButtonVisible(false);
      this.router.navigate(['/settings/maintenance-settings']);
    } else {
      window.location.href = `${environment.eagleOneUrl}${V1RedirectUrls['accountsAndUsers']}`;
    }
  }

  redirectToFleetTrackingPage(): void {
    window.location.href = `${environment.eagleOneUrl}${V1RedirectUrls['fleetTracking']}`
  }
}